import React from 'react';
import { useRecoilValue } from 'recoil';

import Modal from '@/ui-components/Modal';
import Typography from '@/ui-components/Typography';
import Panel, { PanelClose } from '@/ui-components/Panel';
import { Player, PlayerGem, PlayerContent } from '@/ui-components/Player';

import useBem from '@/use/useBem';
import useModal, { openUserProfile } from '@/use/useModal';
import { userPlayerState, opponentPlayerState } from '@/framework/player';
import { userSelector } from '@/framework/user';

const RandomGameModal: React.FC = () => {
  const { bem } = useBem('game-modal');

  const userPlayer = {
    score: useRecoilValue(userPlayerState.score),
    name: useRecoilValue(userPlayerState.name),
    colour: useRecoilValue(userPlayerState.colour),
    country: useRecoilValue(userPlayerState.country),
    userId: useRecoilValue(userPlayerState.userId),
  };

  const opponentPlayer = {
    score: useRecoilValue(opponentPlayerState.score),
    name: useRecoilValue(opponentPlayerState.name),
    colour: useRecoilValue(opponentPlayerState.colour),
    country: useRecoilValue(opponentPlayerState.country),
    userId: useRecoilValue(opponentPlayerState.userId),
  };
  const equippedGem = useRecoilValue(userSelector.user).activeGem;
  const clash =
    !!userPlayer.colour && userPlayer.colour === opponentPlayer.colour;

  const [isOpen, _, props] = useModal('game-random');

  return (
    <Modal isCentered {...props} {...{ isOpen }}>
      <Panel className={bem('')}>
        <PanelClose onClick={props?.onRequestClose} />
        <div className={bem('wrap')}>
          <Typography className={bem('h')} variant="l" component="div">
            Searching for a player
          </Typography>

          <div className={bem('players')}>
            <Player
              turn
              loading={!userPlayer.name}
              onClick={
                userPlayer.userId && userPlayer.userId !== 'anon'
                  ? () => openUserProfile(userPlayer.userId)
                  : undefined
              }
            >
              <PlayerGem type={userPlayer.colour ?? equippedGem} />
              <PlayerContent
                name={userPlayer.name}
                country={userPlayer.country}
                score={userPlayer.score}
              />
            </Player>

            <Typography className={bem('vs')} variant="l">
              VS
            </Typography>

            <Player
              turn
              loading={!opponentPlayer.name}
              onClick={
                opponentPlayer.userId && opponentPlayer.userId !== 'anon'
                  ? () => openUserProfile(opponentPlayer.userId)
                  : undefined
              }
            >
              <PlayerGem type={opponentPlayer.colour} rival={clash} />
              <PlayerContent
                name={opponentPlayer.name}
                country={opponentPlayer.country}
                score={opponentPlayer.score}
              />
            </Player>
          </div>
        </div>
      </Panel>
    </Modal>
  );
};

export default RandomGameModal;
